module.exports = __webpack_public_path__ + "static/media/name-changing.eba58536.png";